import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faBuildingColumns, faHotel, faHouse, faMinus, faPeopleRoof, faPlus, faShop } from '@fortawesome/free-solid-svg-icons'

const Faq = () => {
  const missionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    homeBuying: true,
    makingOffer: false,
    findingHome: false,
  });

  const toggleDropdown = (dropdownName) => {
    if (!dropdowns[dropdownName]) {
      let d = {
        homeBuying: false,
        makingOffer: false,
        findingHome: false,
      }
      setDropdowns({
        ...d,
        [dropdownName]: !dropdowns[dropdownName],
      });
    } else {
      setDropdowns({
        ...dropdownName,
        [dropdownName]: !dropdowns[dropdownName],
      });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }
  }, [missionRef]);

  return (
    <div ref={missionRef} className='bg-faq-bg bg-repeat flex flex-col items-center overflow-hidden w-full'>
      <div className='py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 bg-black bg-opacity-30 flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12 w-full'>
        <div className={`w-full lg:w-1/2 transition-all duration-1000`}>
          <div className='text-white grid grid-cols-2 sm:grid-cols-3 gap-6 sm:gap-8'>
            <div className={`flex flex-col items-center justify-center text-center p-3 rounded-lg bg-white/5 backdrop-blur-xs ${isVisible ? 'animate-slideInTop' : ''}`}>
              <div className='text-3xl sm:text-4xl mb-2 text-bluColor'><FontAwesomeIcon icon={faBuilding} /></div>
              <div className='text-xs sm:text-sm font-semibold tracking-wider'>APARTMENT</div>
            </div>
            <div className={`flex flex-col items-center justify-center text-center p-3 rounded-lg bg-white/5 backdrop-blur-xs ${isVisible ? 'animate-slideInTop' : ''}`}>
              <div className='text-3xl sm:text-4xl mb-2 text-bluColor'><FontAwesomeIcon icon={faHotel} /></div>
              <div className='text-xs sm:text-sm font-semibold tracking-wider'>BUILDING</div>
            </div>
            <div className={`flex flex-col items-center justify-center text-center p-3 rounded-lg bg-white/5 backdrop-blur-xs ${isVisible ? 'animate-slideInTop1' : ''}`}>
              <div className='text-3xl sm:text-4xl mb-2 text-bluColor'><FontAwesomeIcon icon={faPeopleRoof} /></div>
              <div className='text-xs sm:text-sm font-semibold tracking-wider'>CONDOMINIUM</div>
            </div>
            <div className={`flex flex-col items-center justify-center text-center p-3 rounded-lg bg-white/5 backdrop-blur-xs ${isVisible ? 'animate-slideInTop1' : ''}`}>
              <div className='text-3xl sm:text-4xl mb-2 text-bluColor'><FontAwesomeIcon icon={faHouse} /></div>
              <div className='text-xs sm:text-sm font-semibold tracking-wider'>HOUSE</div>
            </div>
            <div className={`flex flex-col items-center justify-center text-center p-3 rounded-lg bg-white/5 backdrop-blur-xs ${isVisible ? 'animate-slideInTop2' : ''}`}>
              <div className='text-3xl sm:text-4xl mb-2 text-bluColor'><FontAwesomeIcon icon={faBuildingColumns} /></div>
              <div className='text-xs sm:text-sm font-semibold tracking-wider'>OFFICE</div>
            </div>
            <div className={`flex flex-col items-center justify-center text-center p-3 rounded-lg bg-white/5 backdrop-blur-xs ${isVisible ? 'animate-slideInTop2' : ''}`}>
              <div className='text-3xl sm:text-4xl mb-2 text-bluColor'><FontAwesomeIcon icon={faShop} /></div>
              <div className='text-xs sm:text-sm font-semibold tracking-wider'>SHOP</div>
            </div>
          </div>
        </div>
        <div className={`w-full lg:w-1/2 flex flex-col space-y-3 ${isVisible ? 'animate-slideInRight' : ''}`}>
          <div onClick={() => toggleDropdown('homeBuying')} className='cursor-pointer rounded-lg overflow-hidden shadow-sm'>
            <div className='flex justify-between items-center bg-white font-semibold px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm'>
              <span>HOME BUYING PROCESS</span>
              <FontAwesomeIcon icon={dropdowns.homeBuying ? faMinus : faPlus} />
            </div>
            <div className={`bg-white/95 overflow-hidden transition-all duration-300 ease-in-out text-xs sm:text-sm text-gray-700 ${dropdowns.homeBuying ? 'max-h-60 px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100' : 'max-h-0'}`}>
              Haideries is an integrated real estate service provider, ranked UAE’s Number 1 agency in the United Arab Emirates. We guide you step-by-step through property search, viewing, mortgage, and transfer.
            </div>
          </div>

          <div onClick={() => toggleDropdown('makingOffer')} className='cursor-pointer rounded-lg overflow-hidden shadow-sm'>
            <div className='flex justify-between items-center bg-white font-semibold px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm'>
              <span>MAKING AN OFFER</span>
              <FontAwesomeIcon icon={dropdowns.makingOffer ? faMinus : faPlus} />
            </div>
            <div className={`bg-white/95 overflow-hidden transition-all duration-300 ease-in-out text-xs sm:text-sm text-gray-700 ${dropdowns.makingOffer ? 'max-h-60 px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100' : 'max-h-0'}`}>
              Our seasoned agents negotiate on your behalf to secure the most favorable purchase price and terms, ensuring your deposit and rights are legally protected.
            </div>
          </div>

          <div onClick={() => toggleDropdown('findingHome')} className='cursor-pointer rounded-lg overflow-hidden shadow-sm'>
            <div className='flex justify-between items-center bg-white font-semibold px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm'>
              <span>FINDING THE RIGHT HOME</span>
              <FontAwesomeIcon icon={dropdowns.findingHome ? faMinus : faPlus} />
            </div>
            <div className={`bg-white/95 overflow-hidden transition-all duration-300 ease-in-out text-xs sm:text-sm text-gray-700 ${dropdowns.findingHome ? 'max-h-60 px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100' : 'max-h-0'}`}>
              With an extensive portfolio across Downtown, Palm Jumeirah, Dubai Marina, and emerging off-plan communities, we pinpoint homes that match your exact lifestyle and budget.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
